import Fallback from './DashboardEdit.fallback';
import { routeEntry } from '../route-utils';

export default routeEntry({
  fallback: <Fallback />,
  component: () => import('./DashboardEdit.page'),
});
